import { Directive } from '@angular/core';
import { Input, ElementRef, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

/**
 * A directive to display citation data.
 */
@Directive({
  selector: '[appCitation]'
})
export class CitationDirective implements OnChanges {
	@Input() citation: string = '';

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {}

	ngOnChanges(changes: SimpleChanges): void {
	    if (changes['citation']) {
	    	this.updateContent();
	    }
	}

	private updateContent(): void {
    	this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.citation);
	}
}